import type { ImageCrop } from './types';

export const DEFAULT_IMAGE_CROP: ImageCrop = Object.freeze({ x: 50, y: 50, zoom: 1 });

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

function finiteNumber(value: unknown, fallback: number) {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

/**
 * Normalizes crop data loaded from persisted JSON. Missing crops remain null so
 * legacy content keeps using the existing centered cover behavior.
 */
export function normalizeImageCrop(value: unknown): ImageCrop | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const crop = value as Partial<Record<keyof ImageCrop, unknown>>;
  return {
    x: clamp(finiteNumber(crop.x, DEFAULT_IMAGE_CROP.x), 0, 100),
    y: clamp(finiteNumber(crop.y, DEFAULT_IMAGE_CROP.y), 0, 100),
    zoom: clamp(finiteNumber(crop.zoom, DEFAULT_IMAGE_CROP.zoom), 1, 3),
  };
}
